
      var _path, _circle, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon100Optic3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 300,
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.323 33.161a1.875 1.875 0 0 1 2.515-.838l3.777 1.889a18.1 18.1 0 0 0 8.106 1.913H43a1.875 1.875 0 1 1 0 3.75H32.72c-3.396 0-6.745-.79-9.782-2.31l-3.778-1.888a1.875 1.875 0 0 1-.838-2.516zm0 21.677a1.875 1.875 0 0 0 2.515.839l3.777-1.889a18.1 18.1 0 0 1 8.106-1.913H43a1.875 1.875 0 1 0 0-3.75H32.72c-3.396 0-6.745.79-9.782 2.309l-3.778 1.889a1.875 1.875 0 0 0-.838 2.515zM43 42.125a1.875 1.875 0 0 1 0 3.75H13a1.875 1.875 0 0 1 0-3.75z",
  fill: "#000"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 32,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 55,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 44,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.875 36A7.875 7.875 0 0 0 60 28.125H27a1.875 1.875 0 0 0 0 3.75h33A4.125 4.125 0 0 1 64.125 36v32.125h-14.18a7.001 7.001 0 0 0-13.89 0H33A4.125 4.125 0 0 1 28.875 64v-6.25a1.875 1.875 0 0 0-3.75 0V64A7.875 7.875 0 0 0 33 71.875h3.616a7.001 7.001 0 0 0 12.768 0h21.232a7.001 7.001 0 0 0 12.768 0H84A7.875 7.875 0 0 0 91.875 64V45A7.875 7.875 0 0 0 84 37.125H67.875zM77 62a7 7 0 0 0-6.946 6.125h-2.179v-27.25H84A4.125 4.125 0 0 1 88.125 45v19A4.125 4.125 0 0 1 84 68.125h-.054A7 7 0 0 0 77 62m-34 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M73.75 69a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"300\" height=\"300\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.323 33.161a1.875 1.875 0 0 1 2.515-.838l3.777 1.889a18.1 18.1 0 0 0 8.106 1.913H43a1.875 1.875 0 1 1 0 3.75H32.72c-3.396 0-6.745-.79-9.782-2.31l-3.778-1.888a1.875 1.875 0 0 1-.838-2.516zm0 21.677a1.875 1.875 0 0 0 2.515.839l3.777-1.889a18.1 18.1 0 0 1 8.106-1.913H43a1.875 1.875 0 1 0 0-3.75H32.72c-3.396 0-6.745.79-9.782 2.309l-3.778 1.889a1.875 1.875 0 0 0-.838 2.515zM43 42.125a1.875 1.875 0 0 1 0 3.75H13a1.875 1.875 0 0 1 0-3.75z\" fill=\"#000\"/><circle cx=\"18\" cy=\"32\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/><circle cx=\"18\" cy=\"55\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/><circle cx=\"12\" cy=\"44\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M67.875 36A7.875 7.875 0 0 0 60 28.125H27a1.875 1.875 0 0 0 0 3.75h33A4.125 4.125 0 0 1 64.125 36v32.125h-14.18a7.001 7.001 0 0 0-13.89 0H33A4.125 4.125 0 0 1 28.875 64v-6.25a1.875 1.875 0 0 0-3.75 0V64A7.875 7.875 0 0 0 33 71.875h3.616a7.001 7.001 0 0 0 12.768 0h21.232a7.001 7.001 0 0 0 12.768 0H84A7.875 7.875 0 0 0 91.875 64V45A7.875 7.875 0 0 0 84 37.125H67.875zM77 62a7 7 0 0 0-6.946 6.125h-2.179v-27.25H84A4.125 4.125 0 0 1 88.125 45v19A4.125 4.125 0 0 1 84 68.125h-.054A7 7 0 0 0 77 62m-34 3.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M73.75 69a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0\" fill=\"#000\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-100-optic@3x.3959c673ab3787449086243beb8f6fee.svg"),
        {
          React: SvgIcon100Optic3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      